import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';

interface GreetingProps {
    name: string;
}

const Greeting: React.FC<GreetingProps> = ({ name }: GreetingProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    return (
        <div className="greeting">
            <h2>{`${strings.HOME_HELLO}, ${name}`}</h2>
        </div>
    );
};

export default Greeting;
